import { Dispatch, SetStateAction, useState } from "react";
import ReactPlayer from "react-player";

import { getVimeoId } from "../../pages/event/utils/getVideoUrl";
import VideoModel from "./VideoModel";

export default function VideoPlayerModal({
  videoTitle,
  videoUrl,
  setShowVideo,
}: {
  videoTitle: string;
  videoUrl: string;
  setShowVideo: Dispatch<SetStateAction<boolean>>;
}) {
  const isVimeo = Boolean(getVimeoId(videoUrl));

  const [isReady, setIsReady] = useState(false);

  return (
    <div>
      <VideoModel
        videoTitle={videoTitle}
        videoUrl={videoUrl}
        setShowVideo={setShowVideo}
      >
        {!isReady ? (
          <div className="absolute left-0 top-0 z-[1] h-full w-full bg-black" />
        ) : null}

        {isVimeo ? (
          <iframe
            title={videoTitle}
            src={`${videoUrl}&autoplay=1`}
            width="100%"
            className="aspect-[16/9]"
            allow="autoplay; fullscreen"
            allowFullScreen
            onLoad={() => setIsReady(true)}
          />
        ) : (
          <ReactPlayer
            width="100%"
            aspectratio="16:9"
            url={videoUrl}
            playing
            playsinline
            muted
            controls
            config={{
              file: {
                attributes: {
                  controlsList: "nodownload",
                  preload: "auto",
                },
              },
            }}
            onReady={() => setIsReady(true)}
          />
        )}
      </VideoModel>
    </div>
  );
}
